export default "__VITE_ASSET__BUbVYP6Y__"